export default "Info in this section is primarily from Google Maps";